import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TReportingType {
  code: string;
  formTypesGroupCategoryCode: string;
  name: string;
  valid: boolean;
  description: string;
  period: number;
  periodMeasureUnit: string;
  repeatingPeriod: boolean;
  periodOfRepetiton?: number;
  periodOfRepetitonMeasureUnit?: string;
  dateFrom: Date;
  dateTo: Date;
  tag: string;
  gracePeriodInDays: number;
  npPeriodFrom?: Date;
  npPeriodTo?: Date;
}

export interface IReportingType extends TReportingType {}

const ReportingType = Model(
  (model: TReportingType): IReportingType => {
    const _reportingType: TReportingType = Object.assign({}, model);

    let create = (reportingType: IReportingType): IReportingType => {
      let obj = ValidatableObject(reportingType);
      return obj;
    };

    let reportingType = {
      get code() {
        return _reportingType.code;
      },
      set code(value) {
        _reportingType.code = value;
      },
      get formTypesGroupCategoryCode() {
        return _reportingType.formTypesGroupCategoryCode;
      },
      set formTypesGroupCategoryCode(value) {
        _reportingType.formTypesGroupCategoryCode = value;
      },
      get name() {
        return _reportingType.name;
      },
      set name(value) {
        _reportingType.name = value;
      },
      get valid() {
        return _reportingType.valid;
      },
      set valid(value) {
        _reportingType.valid = value;
      },
      get description() {
        return _reportingType.description;
      },
      set description(value) {
        _reportingType.description = value;
      },
      get period() {
        return _reportingType.period;
      },
      set period(value) {
        _reportingType.period = value;
      },
      get periodMeasureUnit() {
        return _reportingType.periodMeasureUnit;
      },
      set periodMeasureUnit(value) {
        _reportingType.periodMeasureUnit = value;
      },
      get repeatingPeriod() {
        return _reportingType.repeatingPeriod;
      },
      set repeatingPeriod(value: any) {
        _reportingType.repeatingPeriod = value;
      },
      get periodOfRepetiton() {
        return _reportingType.periodOfRepetiton;
      },
      set periodOfRepetiton(value) {
        _reportingType.periodOfRepetiton = value;
      },
      get periodOfRepetitonMeasureUnit() {
        return _reportingType.periodOfRepetitonMeasureUnit;
      },
      set periodOfRepetitonMeasureUnit(value) {
        _reportingType.periodOfRepetitonMeasureUnit = value;
      },
      get dateFrom() {
        return _reportingType.dateFrom;
      },
      set dateFrom(value) {
        _reportingType.dateFrom = value;
      },
      get dateTo() {
        return _reportingType.dateTo;
      },
      set dateTo(value) {
        _reportingType.dateTo = value;
      },
      get tag() {
        return _reportingType.tag;
      },
      set tag(value) {
        _reportingType.tag = value;
      },
      get gracePeriodInDays() {
        return _reportingType.gracePeriodInDays;
      },
      set gracePeriodInDays(value) {
        _reportingType.gracePeriodInDays = value;
      },
      get npPeriodFrom() {
        return _reportingType.npPeriodFrom;
      },
      set npPeriodFrom(value) {
        _reportingType.npPeriodFrom = value;
      },
      get npPeriodTo() {
        return _reportingType.npPeriodTo;
      },
      set npPeriodTo(value) {
        _reportingType.npPeriodTo = value;
      }
    };

    return create(reportingType);
  }
);

export default ReportingType;
